document.addEventListener('DOMContentLoaded', () => {
    const current_URL = window.location.href;
    const urlWithoutQuery = current_URL.split('?')[0].split('#')[0];

    if (current_URL.indexOf('https://vediclab.com/privacy-policy') != -1) {
        window.location.href = '/pages/privacy-policy';
    } else if (current_URL.indexOf('https://vediclab.com/terms-conditions') != -1) {
        window.location.href = '/pages/terms-conditions';
    } else if (current_URL.indexOf('https://vediclab.com/delete-account') != -1) {
        window.location.href = '/pages/delete-account-form';
    } else if (current_URL.indexOf('https://vediclab.com/citations') != -1) {
        window.location.href = '/pages/citations';
    } else if (current_URL.indexOf('https://vediclab.com/imprint') != -1) {
        window.location.href = '/pages/imprint';
    } else if (current_URL.includes('https://vediclab.com/de/download-app/')) {
        window.location.href = '/de/pages/app';
    } else if (current_URL.includes('https://vediclab.com/de-ch')) {
        window.location.href = 'https://vediclab.com/de';
    } else if (current_URL.includes('/products/free-candle')) {
        window.location.href = '/products/sleep-recovery-candle';
    } else if (
        (current_URL.includes('/collections/all') ||
            current_URL.includes('/collections/night-range') ||
            current_URL.includes('/collections/christmas-special')) &&
        !current_URL.includes('/collections/all-products')
    ) {
        window.location.href = '/collections/all-products';
    } else if (
        urlWithoutQuery.includes('/de') &&
        urlWithoutQuery.includes('/products') &&
        !urlWithoutQuery.endsWith('-de')
    ) {
        window.location.href = `${urlWithoutQuery}-de`;
    }

    const url = window.location.href.split('?')[0].split('#')[0];

    const pattern = /(\/products\/[a-z0-9-]*?)-s2(-de)?$/;

    if (pattern.test(url)) {
        const newUrl = url.replace(pattern, '$1$2');
        window.location.replace(newUrl);
    }
});
